
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/console/company/forgot-password",
      function () {
        return require("private-next-pages/console/company/forgot-password.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/console/company/forgot-password"])
      });
    }
  